import { useState , useEffect } from "react";
import { Button, Space, Table, Tooltip } from "antd";
import { getAllServices, addApiEndpoint, getExistingApis, deleteApiEndpoint } from "../../api/api_endpoints";
import  EndpointForm  from './EndpointForm';
import { useNavigate } from "react-router-dom";
export const AddApiEndpoints = ({onClose}) => {
    const [ datasource, setDatasource ] = useState([{}]);
    const [isLoading , setIsLoading] = useState(true);
    const [isFormVisible, setIsFormVisible] = useState(false);
    const [selectedServiceId, setSelectedServiceId] = useState(null);
    const [isListing, setIsListing] = useState(false);
    const [listingSource, setListingSource] = useState([{}]);
    const navigate = useNavigate();

    const getServices = async () => {
        const services = await getAllServices();
        setDatasource(services.data.data);
        setIsLoading(false);
        
    }
    const handleListApis = async(serviceId) => {
        setSelectedServiceId(serviceId);
        setIsListing(true);
        setIsLoading(true);
        const existingApis = await getExistingApis(serviceId);
        setListingSource(existingApis.data.data);
        setIsLoading(false);
    }
    const handleAddApis = (serviceId) => {
        setSelectedServiceId(serviceId);
        setIsFormVisible(true);
    };

    const handleDeleteApi = async(apiId) => {
        const serviceId = selectedServiceId;
        setIsLoading(true);
        const remainingApi = await deleteApiEndpoint(apiId);
        setListingSource(remainingApi.data.data);
        setIsLoading(false);
    }

    const handleFormSubmit = async (payload) => {
        try {
            const AddedService = await addApiEndpoint(payload); // Assuming this is the API call to save the endpoint
            const message = AddedService.data.data;
            
        } catch (error) {
            console.error("Error adding API:", error);
            
        } finally {
            setIsFormVisible(false);
        }
    };

    useEffect(() => {
        getServices();
    },[]);
    const columns = [
      {
        title: 'Application',
        dataIndex: 'service_name',
        key: 'service_name',
        align: 'center',
        render: (serviceName, record) => {
          return (
            <div style={{ display: 'flex', alignItems: 'center' }}>
            
              <img
                src={`${process.env.REACT_APP_BASE_URL}${record.service_icon}`} 
                alt={`${record.service_name} Icon`}
                style={{
                  width: 25,
                  height: 25,
                  marginRight: 10, 
                }}
              />
              {serviceName}
            </div>
          );
        }
      },
      {
        title: 'Actions',
        dataIndex: 'actions',
        key: 'actions',
        align: 'center',
        render: (_, record) => {
          return (
            <Space>
              <Tooltip title={`List API's for ${record.service_name}`}>
                <Button onClick={() => { handleListApis(record._id) }}>View API's</Button>
              </Tooltip>
              <Tooltip title={`Add API's for ${record.service_name}`}>
                <Button onClick={() => { handleAddApis(record._id) }}>Add API's</Button>
              </Tooltip>
            </Space>
          );
        }
      }
    ];
    const listingColumns = [
        {
            title : 'API Name',
            dataIndex : 'api_name',
            key : 'api_name',
            align : 'center'
        },
        {
            title : 'API Endpoint',
            dataIndex : 'api_endpoint',
            key : 'api_endpoint',
            align : 'center'
        },
        {
            title : 'Method',
            dataIndex : 'method',
            key : 'method',
            align : 'center'
        },
        {
            title : 'Description',
            dataIndex : 'description',
            key : 'description',
            align : 'center'
        },
        {
            title : 'Actions',
            dataIndex : 'actions',
            key : 'actions',
            align : 'center',
            render : (_, record) => {
                return (
                    <Space>
                        <Button onClick={() => {handleDeleteApi(record._id)}}>Delete API</Button>
                    </Space>
                )
            }
        }
    ];

    return (

        <div style={{ margin: "20px" }}>
          <div 
          className="large-icon-container add-api-container"
          >
          <span>Add API's</span>
          {!isListing &&
          <Button  onClick={onClose}>Back</Button>
          }
          </div>

            {isListing ?
                <>
                <Button 
                onClick={() => setIsListing(false)}
                style={{ marginBottom : 10}}>Back</Button>
                
                <Table
                loading={isLoading}
                bordered={true}
                columns={listingColumns}
                dataSource={listingSource}
                pagination={true}
                scroll={{ y: 240 }}
                /> 
                </> :
                <Table
                loading={isLoading}
                bordered={true}
                columns={columns}
                dataSource={datasource}
                pagination={false}
                /> 
            }
            <EndpointForm
                isVisible={isFormVisible}
                onClose={() => setIsFormVisible(false)}
                onSubmit={handleFormSubmit}
                serviceId={selectedServiceId}
            />
        </div>
    ) 

}